import { CommandBase } from "../CommandBase.js";

export class CdCommand extends CommandBase {
    async execute(args) {
        const result = this.fileSystem.cd(args[0]); // args[0] is the pathArg
        
        if (result.type === 'error') {
            this.write(result.content, 'text-red');
        } else {
            // On success, the VFS state is updated, so we tell the terminal to refresh its UI
            this.terminal.updatePrompt();
        }
    }
}